/**
 * Tracks an automatic composer switch Chat only → Allow edits so we can offer
 * switching back after the agent/CTA turn finishes.
 */
let autoSwitchedFromChatToWrite = false;

export function markAutoSwitchedFromChatToWrite(): void {
  autoSwitchedFromChatToWrite = true;
}

export function clearAutoSwitchedFromChatToWrite(): void {
  autoSwitchedFromChatToWrite = false;
}

export function peekAutoSwitchedFromChatToWrite(): boolean {
  return autoSwitchedFromChatToWrite;
}

export function consumeAutoSwitchedFromChatToWrite(): boolean {
  const pending = autoSwitchedFromChatToWrite;
  autoSwitchedFromChatToWrite = false;
  return pending;
}

export function maybeMarkAutoSwitchedFromChatToWrite(
  fromMode: string | undefined,
  toMode: string | undefined,
): void {
  if (fromMode === "chat" && toMode === "write") {
    markAutoSwitchedFromChatToWrite();
  }
}
